module.exports = __webpack_public_path__ + "img/MGH-Toyosu-7-2440x1172.a4406f9a.jpg";